import { useCallback, useEffect } from 'react';
import useSetOneTrustConsent from './useSetOneTrustConsent';

const OT_EVENT = 'OTConsentApplied';

const useOneTrustAtomHandler = () => {
  const setOneTrustConsent = useSetOneTrustConsent();

  const handleConsentApplied = useCallback(() => {
    if (typeof window !== 'undefined' && window.OnetrustActiveGroups) {
      setOneTrustConsent(window.OnetrustActiveGroups.split(',').length > 4);
    }
  }, [setOneTrustConsent]);

  useEffect(() => {
    window.addEventListener(OT_EVENT, handleConsentApplied);

    return () => {
      window.removeEventListener(OT_EVENT, handleConsentApplied);
    };
  }, [handleConsentApplied, setOneTrustConsent]);
};

export default useOneTrustAtomHandler;
